import React, { useEffect, useRef } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import TrustBar from "../components/TrustBar";
import LegalContext from "../components/LegalContext";
import PricingSection from "../components/PricingSection";
import MethodologySection from "../components/MethodologySection";
import FormSection from "../components/FormSection";
import CertificateSection from "../components/CertificateSection";
import GuaranteeSection from "../components/GuaranteeSection";
import CoverageSection from "../components/CoverageSection";
import FAQSection from "../components/FAQSection";
import BottomCTA from "../components/BottomCTA";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

export default function LandingPage() {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    const sections = document.querySelectorAll(".section-reveal");
    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <LegalContext />
        <PricingSection />
        <MethodologySection />
        <FormSection />
        <CertificateSection />
        <GuaranteeSection />
        <CoverageSection />
        <FAQSection />
        <BottomCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
